import { render, staticRenderFns } from "./LegalShopDetail.vue?vue&type=template&id=481b7165&"
import script from "./LegalShopDetail.vue?vue&type=script&lang=js&"
export * from "./LegalShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./LegalShopDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports